import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { $robotoFontFamily } from "@similarweb/styles";
import { setFont } from "@similarweb/styles";

export const StyledExportEmptyState = styled.div`
    text-align: center;
    margin: 60px auto;
`;

export const StyledTitleExportEmptyState = styled.div`
    ${setFont({
        $size: 16,
        $weight: 500,
        $family: $robotoFontFamily,
        $color: colorsPalettes.carbon[500],
    })};
    line-height: 20px;
`;

export const StyledSubTitleExportEmptyState = styled.div`
    ${setFont({
        $size: 12,
        $weight: 400,
        $family: $robotoFontFamily,
        $color: colorsPalettes.carbon[300],
    })};
    line-height: 20px;
`;
